import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({providedIn:'root'})
export class SubscriptionProvider {

    removeSub = new Subject<any>();
    private locater: any = null;

    setLocater(locater: any) {
        this.locater = locater;
    }

    getLocater() {
        return this.locater;
    }

    clearLocater() {
        this.locater = null;
    }
}